// action
import {
    SAVE_PATIENT_PROFILE,
    SAVE_PATIENT_PROFILE_FAIL,
    SAVE_PATIENT_PROFILE_SUCCESS,
    SAVE_PATIENT_PROFILE_RESET
} from '../action/savePatientProfileAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_PATIENT_PROFILE:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_PATIENT_PROFILE_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_PATIENT_PROFILE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_PATIENT_PROFILE_RESET:
            return initialState
        default:
            return state
    }
}